import React, { useEffect, useRef } from "react";

export default function SceneDropdown({ classname, data, onClose, onSelect, anchorRef, selectedValue, classes, isDarkMode }) {
  const dropdownRef = useRef(null);

  // 👉 close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        !anchorRef.current.contains(e.target)
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const baseIndex = selectedValue * 2;
    const scrollTill = baseIndex <= 4 || baseIndex >= 44 ? baseIndex : baseIndex + 2;

    document
      .getElementById(`dropdown-item-${scrollTill}`)
      ?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, [selectedValue]);

  return (
    <div className={`${classes.dropdownWrapper} ${classname === 'timePicker' ? classes.timePicker : ''}`} ref={dropdownRef}>
      {data.map((v, i) => (
        <div
          key={i}
          className={`${classes.dropdownItem} ${data.length - 1 === i ? classes.lastItem : ''} ${(i === selectedValue * 2) ? (classname === 'timePicker' ? classes.selectedTimePicker : classes.selectedItem) : ''}`}
          style={(i === selectedValue * 2 && classname === 'timePicker' && isDarkMode) ? { background: '#00bcd4', color: '#fff' } : undefined}
          onClick={() => {
            onSelect(v);
            onClose();
          }}
          id={`dropdown-item-${i}`}
        >
          {v.color ? <div className={classes.dropdownColor} ><div
            className={classes.dropdownDot}
            style={{ background: v.color }}
          /><span>{v.name || v}</span></div> : null}
          {v.color ? null : <span>{v.name || v}</span>}
          {i !== data.length - 1 && (
            <div className={classes.dropdownDivider} />
          )}
        </div>
      ))}
    </div>
  );
}

